import { Injectable } from '@angular/core';
import {
  AuthRepository,
  DarkModeRepository,
  MenuRepository
} from '@gishub/infrastructure';

/**
 * Providers de repositorios usados por los features vivos:
 *   - geoportal → MenuRepositoryProvider
 *   - auth      → AuthRepositoryProvider
 *   - dark-mode → DarkModeRepositoryProvider
 *
 * Los repositorios de features eliminados fueron removidos. Cuando se
 * agregue un feature nuevo, registrar aquí su repositorio (o crear un
 * archivo de providers por feature).
 */
@Injectable({ providedIn: 'root' })
export class MenuRepositoryProvider {
  readonly instance = new MenuRepository();
}

@Injectable({ providedIn: 'root' })
export class DarkModeRepositoryProvider {
  readonly instance = new DarkModeRepository();
}

@Injectable({ providedIn: 'root' })
export class AuthRepositoryProvider {
  readonly instance: AuthRepository;
  constructor() {
    const externalApiUrl = (window as any).__ENV?.externalApiUrl ?? 'http://localhost:8080/api/v1';
    this.instance = new AuthRepository(externalApiUrl);
  }
}
